export const MODULE_NAME = 'contract';
export const ACCESS_NAME = 'Contractors';
